import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SectionSelector} from '@twpub/core/models/wrappers/section-selector';
import {FieldProps, SelectItem} from '@twpub/core/models';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {ComponentCategory, ControlType} from '@twpub/core/enums';
import {BaseConfigurableComponent} from '@twpub/shared/components/base';
import _ from 'lodash';

import {MultiSelectComponent} from '../multi-select/multi-select.component';

@Component({
  selector: 'pub-section-dropdown',
  templateUrl: './section-dropdown.component.html',
  styleUrls: ['./section-dropdown.component.scss'],
  standalone: true,
  imports: [MultiSelectComponent]
})
export class SectionDropdownComponent extends BaseConfigurableComponent implements SectionSelector {
  static readonly compName = 'SectionDropdownComponent';
  static readonly MULTIPLE_SELECT = 'multipleSelect';
  readonly allSelectedLabel: string = $localize`:@@section.allSelected:All Sections`;
  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;
    override props: FieldProps[] = [this.LABEL_FIELD, this.VISIBLE_FIELD,
      {
        key: SectionDropdownComponent.MULTIPLE_SELECT,
        label: 'Multiple selections',
        controlType: ControlType.Boolean,
        description: 'Allow multiple selections in dropdown'
      }
    ];

    constructor() {
      super(SectionDropdownComponent, SectionDropdownComponent.compName, 'Dropdown List', [ComponentCategory.SectionSelector]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<SectionSelector>(SectionDropdownComponent, this.name, initialConfig);
    }
  }

  @Input() items?: SelectItem[];
  @Input() selectedValues?: string[] = []

  @Output() selectValues = new EventEmitter<string[]>()

  multipleSelect: boolean = false;

  override doUpdate(): void {
    super.doUpdate();
    this.multipleSelect = this.config?.getBoolean(SectionDropdownComponent.MULTIPLE_SELECT, false);
    this.logger.debug('SectionDropdownComponent.doUpdate:', {items: this.items, selectedValues: this.selectedValues})
    let newSelectedValues = this.filterExisting(this.selectedValues);
    if (!newSelectedValues?.length) {
      newSelectedValues = [];
    }
    if (!_.isEqual(newSelectedValues, this.selectedValues)) {
      this.selectedValues = newSelectedValues;
    }
  }

  onSelectValues(selectedValues: string[]) {
    this.logger.debug('SectionDropdownComponent.onSelectValues:', {selectedValues})
    this.selectValues.emit(selectedValues)
  }

  private filterExisting = (langs: string[] | undefined) => {
    if (!langs?.length) return undefined;
    const validSections = langs.filter(code =>
      this.items?.some(l => l.value === code)
    );
    return validSections.length < langs.length ? validSections : langs;
  };
}
